import React from "react";
import ContentLoader from "react-content-loader";

const RankLoading = () => (
  <li>
    <ContentLoader height={142} width={220} speed={2}>
      <rect x="0" y="10" rx="5" ry="5" width="12" height="12" />
      <rect x="20" y="13" rx="3" ry="3" width="200" height="6.4" />
      <rect x="0" y="40" rx="5" ry="5" width="12" height="12" />
      <rect x="20" y="43" rx="3" ry="3" width="200" height="6.4" />
      <rect x="0" y="70" rx="5" ry="5" width="12" height="12" />
      <rect x="20" y="73" rx="3" ry="3" width="200" height="6.4" />
      <rect x="0" y="100" rx="5" ry="5" width="12" height="12" />
      <rect x="20" y="103" rx="3" ry="3" width="200" height="6.4" />
    </ContentLoader>
  </li>
);

export default RankLoading;
